export default {
  hostedOnServer: true,
  workingBranch: "demand", // enter demand or supply when working on localhost
  accessTokenMB: "pk.eyJ1IjoiamJhcnJ1ZXRhIiwiYSI6ImNrb2R3YTA4azAyaWkydW9kcmc4cDkycXIifQ.Fmxskn2HIQ1v4LpXcL4aFw",
  baseURL: "jorgebarrueta.me"
};
